__turbopack_context__.v({
  "btn": "coDpmG_btn",
  "btnFooter": "coDpmG_btnFooter",
  "cards": "coDpmG_cards",
  "cardsWeb": "coDpmG_cardsWeb",
  "category": "coDpmG_category",
  "container": "coDpmG_container",
  "containerCard": "coDpmG_containerCard",
  "contentText": "coDpmG_contentText",
  "h3Platform": "coDpmG_h3Platform",
  "image": "coDpmG_image",
  "imageContainer": "coDpmG_imageContainer",
  "noPaddingCard": "coDpmG_noPaddingCard",
  "pPlatform": "coDpmG_pPlatform",
  "paragraph": "coDpmG_paragraph",
  "rowEtc": "coDpmG_rowEtc",
  "textH2": "coDpmG_textH2",
  "textH2Pink": "coDpmG_textH2Pink",
  "title": "coDpmG_title",
});
